<template>
    <app-layout title="Excel data import">
        <template #header>
            <page-title title="Excel data import" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" class="w-1/3">
                <Select
                    label="Type"
                    name="import_name"
                    :required="true"
                    :options="importOptions"
                    :sortByLabel="false"
                    v-model="form.import_name"
                    :error="form.errors.import_name"
                />
                <Input
                    type="file"
                    label="Excel"
                    name="excel"
                    v-model="form.excel"
                    :error="form.errors.excel"
                />
                <Button
                    buttonClass="Import"
                    text="Importeer excel"
                    type="submit"
                    class="self-end"
                    :loading="form.processing"
                />
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import store from '@/store'
import {useForm} from "@inertiajs/inertia-vue3"
import {ref} from "vue";

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Form,
        Input,
        Select,
    },
    props: [
        'requestTypes',
    ],
    setup (props){
        let importOptions = {
                'adis': "ADI's",
                'missing_amount': 'Ontbrekend factuurbedrag',
                'missing_surface': 'Ontbrekende oppervlakte',
                'missing_analysis': 'Ontbrekende analyse',
                'missing_report_date': 'Ontbrekende datum rapportage',
                'missing_report_time': 'Ontbrekende tijd rapportage',
                'missing_transport_time': 'Ontbrekende tijd transport',
                'missing_visit_time': 'Ontbrekende tijd bezoek',
            }

        const form = useForm({
            import_name: null,
            excel: null,
        })

        function postForm()
        {
            form.post(route('configuration.excel-data-import.data-import'))
        }

        return {
            state: store.state,
            ...store,
            form,
            postForm,
            importOptions,
        }
    },
}

</script>
